import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "saddle-filters" }

import { ref } from 'vue'
import { BfFlex } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { useSaddleStore } from '@/store/saddleStore'
import FilterSummary from '@/components/setup/FilterSummary.vue'
import FilterSummaryItem from '@/components/setup/FilterSummaryItem.vue'
import CommonFilterAccordion from '@/components/setup/common/CommonFilterAccordion.vue'
import CommonCheckFilters from '@/components/setup/common/CommonCheckFilters.vue'
import CommonSliderFilter from '@/components/setup/common/CommonSliderFilter.vue'
import CommonRadioFilters from '@/components/setup/common/CommonRadioFilters.vue'
import type {
  CommonCheckFilterType,
  CommonSliderFilterType,
  CommonRadioFilterType,
} from '@/types/filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaddleFilters',
  setup(__props) {

const { t } = useI18n()

const userStore = useUserStore()
const { sessionId } = storeToRefs(userStore)

const saddleStore = useSaddleStore()
const { filters } = storeToRefs(saddleStore)

const typeSummary = ref()
const widthSummary = ref()
const shapeSummary = ref()
const anatomicalFitSummary = ref()

const loading = ref(false)

const saddleTypeFilters: CommonCheckFilterType = {
  TypeRoad: {
    label: t('common.bike.type.road'),
    icons: {
      default: '/icons/filters/bike__road.svg',
      selected: '/icons/filters/bike__road--selected.svg',
    },
  },
  TypeGravel: {
    label: t('common.bike.type.gravel'),
    icons: {
      default: '/icons/filters/bike__gravel.svg',
      selected: '/icons/filters/bike__gravel--selected.svg',
    },
  },
  TypeCyclocross: {
    label: t('common.bike.type.cyclocross'),
    icons: {
      default: '/icons/filters/bike__cyclocross.svg',
      selected: '/icons/filters/bike__cyclocross--selected.svg',
    },
  },
  TypeTimeTrial: {
    label: t('common.bike.type.timeTrial'),
    icons: {
      default: '/icons/filters/bike__time-trial.svg',
      selected: '/icons/filters/bike__time-trial--selected.svg',
    },
  },
  TypeFullTriathlon: {
    label: t('common.bike.type.fullTriathlon'),
    icons: {
      default: '/icons/filters/bike__trifull.svg',
      selected: '/icons/filters/bike__trifull--selected.svg',
    },
  },
  TypeShortTriathlon: {
    label: t('common.bike.type.shortTriathlon'),
    icons: {
      default: '/icons/filters/bike__trishort.svg',
      selected: '/icons/filters/bike__trishort--selected.svg',
    },
  },
  TypeMtbCrossCountry: {
    label: t('common.bike.type.mtbCrossCountry'),
    icons: {
      default: '/icons/filters/bike__mtb-cx.svg',
      selected: '/icons/filters/bike__mtb-cx--selected.svg',
    },
  },
  TypeMtbTrail: {
    label: t('common.bike.type.mtbTrail'),
    icons: {
      default: '/icons/filters/bike__mtb-trial.svg',
      selected: '/icons/filters/bike__mtb-trial--selected.svg',
    },
  },
  TypeTrekking: {
    label: t('common.bike.type.trekking'),
    icons: {
      default: '/icons/filters/bike__trekking.svg',
      selected: '/icons/filters/bike__trekking--selected.svg',
    },
  },
  TypeCity: {
    label: t('common.bike.type.city'),
    icons: {
      default: '/icons/filters/bike__city.svg',
      selected: '/icons/filters/bike__city--selected.svg',
    },
  },
}

const saddleShapeFilters: CommonCheckFilterType = {
  ShapeFlat: {
    label: t('setup.saddle.shape.flat'),
    icons: {
      default: '/icons/filters/saddle-shape__flat.svg',
      selected: '/icons/filters/saddle-shape__flat--selected.svg',
    },
  },
  ShapeSemiCurved: {
    label: t('setup.saddle.shape.semiCurved'),
    icons: {
      default: '/icons/filters/saddle-shape__semi.svg',
      selected: '/icons/filters/saddle-shape__semi--selected.svg',
    },
  },
  ShapeCurved: {
    label: t('setup.saddle.shape.curved'),
    icons: {
      default: '/icons/filters/saddle-shape__curved.svg',
      selected: '/icons/filters/saddle-shape__curved--selected.svg',
    },
  },
}

const anatomicalFitFilters: CommonRadioFilterType = {
  AnatomicalFit: {
    no: {
      label: t('common.no'),
      summary: t('setup.saddle.nonAnatomicalFit'),
      value: 'false',
      icons: {
        default: '/icons/filters/saddle-anatomical__no.svg',
        selected: '/icons/filters/saddle-anatomical__no--selected.svg',
      },
    },
    yes: {
      label: t('common.yes'),
      summary: t('setup.saddle.anatomicalFit'),
      value: 'true',
      icons: {
        default: '/icons/filters/saddle-anatomical__yes.svg',
        selected: '/icons/filters/saddle-anatomical__yes--selected.svg',
      },
    },
  },
}

const saddleWithFilter: CommonSliderFilterType = {
  value: {
    Width: filters.value.Width ?? 100,
  },
  min: {
    MinWidth: 100,
  },
  max: {
    MaxWidth: 250,
  },
}

const search = (e?: Record<string, any>) => {
  saddleStore.reset()

  if (e) saddleStore.setFilters(e)

  saddleStore.retrieveSaddles(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(t)('common.properties')), 1),
    _createVNode(_unref(BfFlex), { direction: "column" }, {
      default: _withCtx(() => [
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.saddle.bike'),
          icon: "/icons/filters/bike.svg"
        }, {
          default: _withCtx(() => [
            _createVNode(CommonCheckFilters, {
              filters: saddleTypeFilters,
              onUpdated: _cache[0] || (_cache[0] = ($event: any) => (search($event))),
              onSummary: _cache[1] || (_cache[1] = ($event: any) => (typeSummary.value = $event))
            })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.saddle.width'),
          icon: "/icons/filters/saddle__width.svg"
        }, {
          default: _withCtx(() => [
            _createVNode(CommonSliderFilter, {
              unit: _unref(t)('common.unit.mm'),
              "summary-prefix": _unref(t)('setup.saddle.width'),
              filter: saddleWithFilter,
              onUpdated: _cache[2] || (_cache[2] = ($event: any) => (search($event))),
              onSummary: _cache[3] || (_cache[3] = ($event: any) => (widthSummary.value = $event))
            }, null, 8, ["unit", "summary-prefix"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.saddle.shape.index'),
          icon: "/icons/filters/saddle-shape__flat.svg"
        }, {
          default: _withCtx(() => [
            _createVNode(CommonCheckFilters, {
              filters: saddleShapeFilters,
              onUpdated: _cache[4] || (_cache[4] = ($event: any) => (search($event))),
              onSummary: _cache[5] || (_cache[5] = ($event: any) => (shapeSummary.value = $event))
            })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.saddle.anatomicalFit'),
          icon: "/icons/filters/saddle-anatomical__yes.svg"
        }, {
          default: _withCtx(() => [
            _createVNode(CommonRadioFilters, {
              filters: anatomicalFitFilters,
              onUpdated: _cache[6] || (_cache[6] = ($event: any) => (search($event))),
              onSummary: _cache[7] || (_cache[7] = ($event: any) => (anatomicalFitSummary.value = $event))
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(FilterSummary, null, {
      default: _withCtx(() => [
        (typeSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(typeSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (widthSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(widthSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (shapeSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 2 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(shapeSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (anatomicalFitSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 3 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(anatomicalFitSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})